import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingImage: false,
  image:null,
  imgStatus:null
};


const imageSlice = createSlice({
    name: "image",
    initialState,
    reducers: {
        getImageFile(state, action){
          state.loadingImage = false;
          state.image = action.payload;
          state.loadingImage = true;
      },
      getImageStatusFile(state, action){
        state.loadingImage = false;
        state.imgStatus = action.payload;
        state.loadingImage = true;
    },
      loading(state, action) {
        state.loadingImage = action.payload;
      },
    },
  });

  export default imageSlice.reducer;
  export const {
    loading,
    getImageFile,
    getImageStatusFile
  } = imageSlice.actions;